export default "__VITE_ASSET__DaK9efoZ__"